// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mup-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 24px 16px;
}

.mup-card {
  width: 100%;
  max-width: 380px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 32px 24px;
  text-align: center;
}

.mup-card h1 {
  font-size: 20px;
  margin: 0 0 8px;
  color: #1a202c;
}

.mup-subtitle {
  color: #718096;
  font-size: 14px;
  margin: 0 0 28px;
}

.mup-add-btn {
  width: 100%;
  padding: 16px;
  background: #2d3748;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
}

.mup-add-btn:hover {
  background: #1a202c;
}

.mup-progress {
  padding: 20px 0 28px;
}

.mup-spinner {
  width: 36px;
  height: 36px;
  margin: 0 auto 16px;
  border: 3px solid #e2e8f0;
  border-top-color: #2d3748;
  border-radius: 50%;
  animation: mup-spin 0.8s linear infinite;
}

@keyframes mup-spin {
  to { transform: rotate(360deg); }
}

.mup-progress p {
  color: #4a5568;
  font-size: 14px;
  margin: 0;
}

.mup-success {
  padding: 8px 0 24px;
}

.mup-check {
  width: 52px;
  height: 52px;
  line-height: 52px;
  margin: 0 auto 14px;
  background: #38a169;
  color: #fff;
  border-radius: 50%;
  font-size: 26px;
  font-weight: 700;
}

.mup-success p {
  margin: 4px 0;
  color: #1a202c;
  font-size: 15px;
}

.mup-hint {
  color: #718096 !important;
  font-size: 13px !important;
}

.mup-error {
  color: #c53030;
  font-size: 14px;
  margin: 0 0 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MobileUploadPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".mup-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  padding: 24px 16px;\n}\n\n.mup-card {\n  width: 100%;\n  max-width: 380px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  padding: 32px 24px;\n  text-align: center;\n}\n\n.mup-card h1 {\n  font-size: 20px;\n  margin: 0 0 8px;\n  color: #1a202c;\n}\n\n.mup-subtitle {\n  color: #718096;\n  font-size: 14px;\n  margin: 0 0 28px;\n}\n\n.mup-add-btn {\n  width: 100%;\n  padding: 16px;\n  background: #2d3748;\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.mup-add-btn:hover {\n  background: #1a202c;\n}\n\n.mup-progress {\n  padding: 20px 0 28px;\n}\n\n.mup-spinner {\n  width: 36px;\n  height: 36px;\n  margin: 0 auto 16px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2d3748;\n  border-radius: 50%;\n  animation: mup-spin 0.8s linear infinite;\n}\n\n@keyframes mup-spin {\n  to { transform: rotate(360deg); }\n}\n\n.mup-progress p {\n  color: #4a5568;\n  font-size: 14px;\n  margin: 0;\n}\n\n.mup-success {\n  padding: 8px 0 24px;\n}\n\n.mup-check {\n  width: 52px;\n  height: 52px;\n  line-height: 52px;\n  margin: 0 auto 14px;\n  background: #38a169;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.mup-success p {\n  margin: 4px 0;\n  color: #1a202c;\n  font-size: 15px;\n}\n\n.mup-hint {\n  color: #718096 !important;\n  font-size: 13px !important;\n}\n\n.mup-error {\n  color: #c53030;\n  font-size: 14px;\n  margin: 0 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
